// extracted by mini-css-extract-plugin
module.exports = {"input":"fncRadioButton_input__1pYj-","label":"fncRadioButton_label__3tv5o","isVertical":"fncRadioButton_isVertical__1o_Ge"};